module.exports = __webpack_public_path__ + "static/media/simcard.705e4a1d.svg";